import $ from 'jquery';

const ACTIVE = 'active';
const search = () => {
  const searchOverlay = $('.c-search-overlay');
  const searchInput = searchOverlay.find('#s');
  const searchOpen = $('.c-main-nav__search');
  const searchClose = $('.c-search-overlay__close');

  if (searchOpen.length) {
    searchOpen.click(ev => {
      ev.preventDefault();
      searchOverlay.addClass(ACTIVE);
      searchInput.focus();
    });
  }

  if (searchClose.length) {
    searchClose.click(ev => {
      ev.preventDefault();
      searchOverlay.removeClass(ACTIVE);
      searchInput.blur();
    });
  }
};
export default search;



// WEBPACK FOOTER //
// ./src/scripts/modules/search.js